import { render, staticRenderFns } from "./peak.vue?vue&type=template&id=0909963c&scoped=true&"
import script from "./peak.vue?vue&type=script&lang=js&"
export * from "./peak.vue?vue&type=script&lang=js&"
import style0 from "./peak.vue?vue&type=style&index=0&id=0909963c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0909963c",
  null
  
)

export default component.exports